import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {leftPanelTopbarPaddingWidth} from '../../../../libs/shared/ui/src/components/leftPanel/leftPanelHelpers';
import {TraceBrowser} from './trace/traceBrowser';

/*
 * Props.
 */

interface LeftPanelTopbarProps {}

/*
 * Style.
 */

const StyledTopbarDiv = styled.div`
  padding-top: 8px;
  padding-left: ${leftPanelTopbarPaddingWidth}px;
  padding-right: ${leftPanelTopbarPaddingWidth}px;
  padding-bottom: 12px;

  background: transparent;
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: auto;
  grid-row-gap: 16px;
`;

/*
 * Component.
 */

export const LeftPanelTopbar: FC<PropsWithChildren<LeftPanelTopbarProps>> = ({children}) => (
  <>
    <StyledTopbarDiv>{children}</StyledTopbarDiv>
    <TraceBrowser />
  </>
);
